module.exports = __webpack_public_path__ + "img/edit.2927f8de.svg";